export default __webpack_public_path__ + "static/s6-255b9fea82be07bce15aad88d0650a9c.jpg";